import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import { Map } from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Map({})
	.set('additionalInfo', new Map({}))
	.set('informationYear', new Map({}))
	.set('resetedData', new Map({}))

/* Types */
export const GET_ADDITIONAL_INFO = 'GET_ADDITIONAL_INFO'
export const GET_ADDITIONAL_YEAR = 'GET_ADDITIONAL_YEAR'

export const UPDATE_ADDITIONAL_INFO = 'UPDATE_ADDITIONAL_INFO'
export const CLEAR_TEMP_ADDITIONAL_INFO = 'CLEAR_TEMP_ADDITIONAL_INFO'


/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_ADDITIONAL_INFO:
			return state.set('additionalInfo',new Map(action.Obj))
		case UPDATE_ADDITIONAL_INFO:
			return state.set('additionalInfo',new Map(action.Obj))
		case GET_ADDITIONAL_YEAR:
			return state.set('informationYear',new Map(action.Obj))
		case CLEAR_TEMP_ADDITIONAL_INFO:
			return state.set('resetedData', new Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getAdditionalInfo = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getGeneralInformation',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));

			let data = response.data
			data.uniqueId = Utils.getUUID();
			response.data = { ...response.data,
				enfoqueCartera: response.data.enfoqueCartera || {
					esEliminado: false,
					idEnfoque: null,
					idDetalle: form.idDonataria,
					cuentaConEnfoqueSistemico : "",
					proyectoEnfoqueSistemico : "",
					principalesProgramas : ""
				},
				carteras: response.data.carteras || { cartera: [] },
				proveedores: response.data.proveedores || { proveedor: [] },
				donantes: response.data.donantes || { donante: [] },
				alianzas: response.data.alianzas || { alianza: [] },
				evaluacionMonitoreo: response.data.evaluacionMonitoreo || {
					esEliminado: false,
					idEvaluacionMonitoreo: null,
					idDetalle: form.idDonataria,
					cuentaConInstrumentos : "",
					nombreInstrumentos : "",
					tipoInformacionSolicitada : "",
					periodicidadInformacion : "",
					titularesResponsabilidades : "",
					utilizaHerramientasTecnologicas : "",
					nombreHerramientasTecnologicas : "",
					usoDatosAnalizados : "",
					programasSometidosAEvaluacion : "",
					tiposEvaluacionEnOrganizacion : ""
				},
				resultado: response.data.resultado || {
					esEliminado: false,
					idResultado: null,
					idDetalle: form.idDonataria,
					resultadoPrograma : "",
					participacionTitularesDerecho : "",
					participacionTitularesResponsabilidad : "",
					participacionTitularesObligacion : "",
					informacionAdicional : "",
					impactoDemostrado: ""
				}
			}

			dispatch({type: GET_ADDITIONAL_INFO, Obj: response.data})
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}
export const getCatalogInformacionAnual = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getCatalogInformacionAnual',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));
			dispatch({type: GET_ADDITIONAL_YEAR, Obj: response.data.data[0]})
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}
export const updateAdditionalInfo = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/updateGeneralInformation',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));
			dispatch({type: UPDATE_ADDITIONAL_INFO, Obj: response.data})
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}


// WEBPACK FOOTER //
// ./src/modules/Grantees/Information/AdditionalInfo.js